var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-section',{attrs:{"sub-title":_vm.$t('views.contact.subTitle'),"title":_vm.$t('views.contact.title')}},[_c('form-contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }